__webpack_require__.p = "https://static.parastorage.com/services/restaurant-menus-showcase-ooi/eb263a9d166d2a2ec0430fd02ab06f3cc0999e2df1c7fb9909349fe1/";